module.exports = __webpack_public_path__ + "img/tab_zhuoganlian_1.98c5c7d7.png";